import { create } from 'zustand';

interface CursorImageContainerState {
  value: { src: string; alt: string; originWidth: number; originHeight: number } | null;
  setValue: (update: { src: string; alt: string; originWidth: number; originHeight: number } | null) => void;
}

export const useCursorContainerStore = create<CursorImageContainerState>((set) => {
  return {
    value: null,
    setValue: (value) => set({ value: value }),
  };
});

export default useCursorContainerStore;
